/** Build-time bundle identity (Vite define / CI env). Proves which JS the browser executed. */
export const BUNDLE_GIT_SHA = (import.meta.env.VITE_GIT_SHA || '').trim() || 'unknown';
export const BUNDLE_BUILD_ID = (import.meta.env.VITE_BUILD_ID || '').trim() || 'unknown';

const BOOT_LOG_PREFIX = '[cordexa-bundle]';

/** Stamp DOM + console at SPA boot so operators and UAT can answer Q1 without DevTools Network. */
export function stampBundleAtBoot(): void {
  const sha = BUNDLE_GIT_SHA;
  const buildId = BUNDLE_BUILD_ID;
  document.documentElement.dataset.cordexaBundleGitSha = sha;
  document.documentElement.dataset.cordexaBundleBuildId = buildId;
  // eslint-disable-next-line no-console
  console.info(`${BOOT_LOG_PREFIX} git_sha=${sha} build_id=${buildId}`);
}
